import { DwUser } from "@devwareapps/devware-cap";
import { FitnessUserTypeIds } from "./fitness-user-type.enum";
import { AdminUserProperties } from "./admin-user-properties.model";
import { AppPermissions } from "../../../meta-data/app-permissions.enum";

export class FitnessUser {

    user: DwUser;

    UserTypeId: FitnessUserTypeIds;

    constructor(user: DwUser, adminUserProperties: AdminUserProperties) {
        this.setupUser(user, adminUserProperties);
    }

    private setupUser(user: DwUser, adminUserProperties?: AdminUserProperties) {
        this.user = user;
        this.UserTypeId = adminUserProperties?.userTypeMode || this.getExtenedAttributeInt('UserTypeId');
    }

    private getExtenedAttribute(name: string): string {
        const userTypeAttr = this.user?.ExtendedAttributes?.find(a => a.AttrName == name);

        if (userTypeAttr) {
            return userTypeAttr.AttrValue;
        }

        return null;
    }

    private getExtenedAttributeInt(name: string): number {
        const value = this.getExtenedAttribute(name);

        if (value) {
            return parseInt(value);
        }

        return null;
    }

    hasPermission(permission: AppPermissions): any {
        return this.user?.Permissions?.includes(permission);
    }
}
